import { render, staticRenderFns } from "./PointOrderDetail.vue?vue&type=template&id=4647060c&scoped=true"
import script from "./PointOrderDetail.vue?vue&type=script&lang=js"
export * from "./PointOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./PointOrderDetail.vue?vue&type=style&index=0&id=4647060c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4647060c",
  null
  
)

export default component.exports